import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OpenaiService {
  private apiUrlBox = 'http://127.0.0.1:7000/api/generate-box-response';  // Endpoint for individual box responses
  private apiUrlCommon = 'http://127.0.0.1:7000/api/generate-common-response';  // Endpoint for common responses
  private apiUrl = 'http://127.0.0.1:7000/api/generate-response';  // Your Flask endpoint

  constructor(private http: HttpClient) {}

  // Fetch individual box response (for example: "Book Titles", "Blog Post")
  fetchResponseForBox(payload: { title: string; prompt: string; creativity: number }): Observable<any> {
    const payloadWithDb = { ...payload, db_name: environment.dbName };
    return this.http.post<any>(this.apiUrlBox, payloadWithDb).pipe(
      catchError((error: any) => {
        console.error('Error occurred while fetching the response:', error);
        return throwError(() => new Error('Unable to fetch response'));
      })
    );
  }

  // Fetch response for all boxes at once (common prompt)
  fetchCommonResponse(payload: { prompt: string; creativity: number }): Observable<any> {
    const payloadWithDb = { ...payload, db_name: environment.dbName };
    return this.http.post<any>(this.apiUrlCommon, payloadWithDb).pipe(
      catchError((error: any) => {
        console.error('Error occurred while fetching the common response:', error);
        return throwError(() => new Error('Unable to fetch common response'));
      })
    );
  }
}
